import React from 'react'
import {Outlet} from 'react-router-dom'

import cls from './main.module.scss'


export const Main = () => {
    return (
        <div className={cls.Main}><Outlet/></div>
    )
}
